import type { PaginatedRoles, UserRole } from '@/types/roles';

import { getStoredToken } from './apiClient';
import { ApiError, authenticatedRequest } from './base.service';

/**
 * Roles Service
 * Handles all role-related API endpoints from /api/v1/roles/* and /api/v1/user-roles/*
 */

export const rolesService = {
  /**
   * Get roles for an organization
   */
  async getRoles(organizationId?: string): Promise<PaginatedRoles> {
    const token = getStoredToken();
    if (!token) throw new ApiError('No authentication token found', 401);

    const url = organizationId ? `/api/v1/roles?organizationId=${organizationId}` : '/api/v1/roles';

    return authenticatedRequest<PaginatedRoles>(url, {}, token);
  },

  /**
   * Get user roles by user ID
   */
  async getUserRoles(userId: string): Promise<UserRole[]> {
    const token = getStoredToken();
    if (!token) throw new ApiError('No authentication token found', 401);

    return authenticatedRequest<UserRole[]>(`/api/v1/user-roles/user/${userId}`, {}, token);
  },
};
